<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-4
        h4.card-title.mb-0
          | Intents List
        div.small.text-muted
          | Displaying Analytics Of Top Intents In Table
      div.col-sm-8
        div.dateRangePickerContainerTable
          i(class="fa fa-calendar")
          date-range-picker.ml-2.dateRangePicker(ref="ref" :options="options")
          i(class="fa fa-caret-down")
        div.pull-right.ml-1.hidden-sm-down
          b-dropdown.float-right(variant='transparent p-0')
            template(slot='button-content')
              img(:src='"static/img/download.png"', alt='' style="width: 14px; height: 14px;")
            b-dropdown-item-button(@click='clickDownloadxlsx', variant='primary')
              | Download as xlsx
            b-dropdown-item-button(@click='clickDownloadpdf', variant='primary')
              | Download as pdf
    br
    app-conversationtopictable(:data='totalTableItems', :label='totalTableFields')
    br
    app-conversationtopictable(:data='tableItems', :label='tableFields')
</template>

<script>
// import { db } from '@/firebase'
import { exportIntentListExcel, exportIntentListPdf } from '@/jsonToXlsx'
import $ from 'jquery'
import sampleData from './sample-data.json'

var moment = require('moment')
// const anaRef = db.ref('analytics')

export default {
  name: 'dashboard',
  components: {
  },
  data() {
    return {
      options: {
        startDate: moment('20190826').subtract(30, 'days'),
        endDate: moment('20190826'),
        locale: {
          format: 'DD/MM/YYYY',
        },
        ranges: {
          'Last 7 Days': [moment('20190826').subtract(6, 'days'), moment('20190826')],
          'Last 30 Days': [moment('20190826').subtract(30, 'days'), moment('20190826')],
          'This Month': [moment('20190826').startOf('month'), moment('20190826').endOf('month')],
          'Last Month': [moment('20190826').subtract(1, 'month').startOf('month'), moment('20190826').subtract(1, 'month').endOf('month')],
        },
      },
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      tableItems: [],
      tableFields: {
        name: {
          label: 'Name of Intent',
          sortable: true,
          tdClass: 'titleWidthInTable',
        },
        category: {
          label: 'Category',
          sortable: true,
          tdClass: 'categoryWidthInTable',
        },
        number: {
          label: 'Number',
          sortable: true,
          sortDesc: 'Descending',
          tdClass: 'categoryWidthInTable',
        },
        percent: {
          label: 'Percent',
          sortable: true,
          tdClass: 'categoryWidthInTable',
        },
      },
      totalTableItems: [],
      totalTableFields: {
        name: {
          label: 'Total',
          tdClass: 'titleWidthInTable',
        },
        category: {
          label: '',
          tdClass: 'categoryWidthInTable',
        },
        number: {
          label: 'Number',
          tdClass: 'categoryWidthInTable',
        },
        percent: {
          label: 'Percent',
          tdClass: 'categoryWidthInTable',
        },
      },
    }
  },
  mounted: function() {
    const el = $(this.$refs.ref.$el)
    const that = this
    el.on('apply.daterangepicker', (event, picker) => {
      let data = JSON.parse(JSON.stringify(this.fullData))
      this.sliderStartTime = new Date(picker.startDate.format('L'))
      this.sliderEndTime = new Date(picker.endDate.format('L'))
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < that.sliderStartTime) {
          delete data[key]
        } else if (keyTime > that.sliderEndTime) {
          delete data[key]
        }
      })
      this.loadData(data)
    })
    this.getTable()
  },
  methods: {
    getTable() {
      const that = this
      this.fullData = sampleData.daily
      let data = JSON.parse(JSON.stringify(this.fullData))
      this.sliderEndTime = new Date('26-08-2019')
      this.sliderStartTime = new Date(this.sliderEndTime - 30 * 24 * 60 * 60 * 1000)
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < that.sliderStartTime) {
          delete data[key]
        } else if (keyTime > that.sliderEndTime) {
          delete data[key]
        }
      })
      this.loadData(data)
    },
    loadData(data) {
      const self = this
      let listOfIntentName = []
      let listOfTotalIntent = []
      const msgs = []
      const totalMsgs = []
      let totalNumber = 0
      let numberUnmatch = 0
      let totalTopics = {}
      Object.entries(data).forEach(function([key, val]) {
        const dailyDatas = Object.values(val)
        Object.entries(dailyDatas[0]).forEach(([intentName, intentData]) => {
          if (!totalTopics[intentName]) {
            totalTopics[intentName] = {
              interactions: 0,
            }
          }
          totalTopics[intentName].interactions += intentData.interactions || 0
          if (intentName == 'Default Fallback Intent') {
            numberUnmatch += intentData.interactions
          }
          totalNumber += intentData.interactions || 0
        })
      })
      Object.entries(totalTopics).forEach(([intentName, intentData]) => {
        if (intentData.interactions != 0) {
          listOfIntentName.push(intentName)
          intentData.interactions = intentData.interactions || 0
          listOfTotalIntent.push(intentData.interactions)
        }
      })
      var keysSorted = []
      for (var i = 0; i < listOfTotalIntent.length; i++) {
        keysSorted.push(i) // add index to output array
      }
      keysSorted.sort(function(a, b) { return listOfTotalIntent[b] - listOfTotalIntent[a] })
      let topListOfTotalIntent = []
      let topListOfIntentName = []
      let category = ''
      for (let i = 0; i < listOfTotalIntent.length; i += 1) {
        topListOfTotalIntent.push(listOfTotalIntent[keysSorted[i]])
        topListOfIntentName.push(listOfIntentName[keysSorted[i]])
        if (listOfIntentName[keysSorted[i]].includes('Small') || listOfIntentName[keysSorted[i]].includes('ST0')) {
          category = 'Small Talks'
        } else if (listOfIntentName[keysSorted[i]].includes('i10')) {
          category = 'General Info'
        } else if (listOfIntentName[keysSorted[i]].includes('i11')) {
          category = 'Cust Service'
        } else if (listOfIntentName[keysSorted[i]].includes('i12')) {
          category = 'Getting There'
        } else if (listOfIntentName[keysSorted[i]].includes('i20')) {
          category = 'Room'
        } else if (listOfIntentName[keysSorted[i]].includes('i21')) {
          category = 'Reservations'
        } else if (listOfIntentName[keysSorted[i]].includes('i22')) {
          category = 'Booking'
        } else if (listOfIntentName[keysSorted[i]].includes('i23')) {
          category = 'Membership'
        } else if (listOfIntentName[keysSorted[i]].includes('i31')) {
          category = 'Casino'
        } else if (listOfIntentName[keysSorted[i]].includes('i32')) {
          category = 'Concert'
        } else if (listOfIntentName[keysSorted[i]].includes('i33')) {
          category = 'Attractions'
        } else if (listOfIntentName[keysSorted[i]].includes('i34')) {
          category = 'Dining'
        } else {
          category = 'Others'
        }
        msgs.push({
          name: listOfIntentName[keysSorted[i]],
          number: listOfTotalIntent[keysSorted[i]],
          category,
          percent: `${(listOfTotalIntent[keysSorted[i]] / totalNumber * 100).toFixed(1)}%`,
        })
      }
      totalMsgs.push({
        name: 'Total Intents',
        number: totalNumber,
        percent: `100%`,
        _rowVariant: 'success',
      })
      totalMsgs.push({
        name: 'Total Matched',
        number: totalNumber - numberUnmatch,
        percent: `${((totalNumber - numberUnmatch) / totalNumber * 100).toFixed(1)}%`,
        _rowVariant: 'warning',
      })
      totalMsgs.push({
        name: 'Total Unmatched',
        number: numberUnmatch,
        percent: `${((numberUnmatch) / totalNumber * 100).toFixed(1)}%`,
        _rowVariant: 'danger',
      })
      self.tableItems = msgs
      self.totalTableItems = totalMsgs
    },
    clickDownloadxlsx() {
      const that = this
      let data = JSON.parse(JSON.stringify(this.fullData))
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < that.sliderStartTime) {
          delete data[key]
        } else if (keyTime > that.sliderEndTime) {
          delete data[key]
        }
      })
      const startDate = this.formatDate(that.sliderStartTime)
      const endDate = this.formatDate(that.sliderEndTime)
      exportIntentListExcel(data, startDate, endDate)
    },
    clickDownloadpdf() {
      const that = this
      let data = JSON.parse(JSON.stringify(this.fullData))
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < that.sliderStartTime) {
          delete data[key]
        } else if (keyTime > that.sliderEndTime) {
          delete data[key]
        }
      })
      const startDate = this.formatDate(that.sliderStartTime)
      const endDate = this.formatDate(that.sliderEndTime)
      exportIntentListPdf(data, startDate, endDate)
    },
    formatDate: function(date) {
      var month = '' + (date.getMonth() + 1)
      var day = '' + date.getDate()
      var year = date.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [day, month, year].join('/')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/IntentsList.vue?6fc4f959